export const HELLO_WORLD = 'HELLO_WORLD'



// WEBPACK FOOTER //
// ./src/store/actionTypes.js